import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {TradeStore} from '../../../pages/trade/trade.store';
import {RoleAssignmentDto} from '../../../../models/generated-models';
import {CurrentUserContextService} from '../../services/current-user-context.service';
import {Router} from '@angular/router';

/**
 * Red notice band shown below the top nav whenever the user has switched
 * into an "act on behalf of" role. App-wide (desktop + mobile layouts).
 */
@Component({
  selector: 'app-acting-as-banner',
  standalone: true,
  templateUrl: './acting-as-banner.component.html',
  styleUrl: './acting-as-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActingAsBannerComponent {
  protected readonly store = inject(TradeStore);
  private readonly currentUser = inject(CurrentUserContextService);
  private readonly router = inject(Router);

  protected get assignment(): RoleAssignmentDto | null {
    return this.store.activeRoleAssignment();
  }

  protected switchBack(): void {
    this.store.selectActiveRoleAssignment(null).finally(() => {
      this.currentUser.refresh().subscribe({
        next: () => {
          this.reloadAndRedirectToProfile();
        },
        error: () => {
          this.reloadAndRedirectToProfile();
        }
      });
    });
  }

  private reloadAndRedirectToProfile(): void {
    const target = '/ui/profile';
    const isProfile = window.location.pathname.replace(/\/+$/, '') === target
      || this.router.url.split('?')[0].split('#')[0] === '/profile';
    if (isProfile) {
      window.location.reload();
    } else {
      window.location.href = target;
    }
  }
}
